/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { regexSearch } from '../util'
import Backbone from '@polleverywhere/backbone'
import User from './user'

export default class Users extends Backbone.Collection {
  get model () { return User }

  url () {
    return '/account/users'
  }

  search (term) {
    const regex = regexSearch(term)
    return this.filter(u =>
      regex.test(u.get('first_name')) ||
      regex.test(u.get('last_name')) ||
      regex.test(u.get('login')) ||
      regex.test(u.get('email'))
    )
  }
}
